import _defineProperty from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _restCommandParams;
import { accessModes, apiSections, dmpconnectActionConstants, mssActionConstants, userAuthenticationModes } from '../../constants';
import { getActiveMssAccountConfig, getConfigurationValue, getInteropCodesFromState } from '../../helpers/accessors';
import { b64DecodeUnicode } from '../../utils/dataUtils';
import { dmpCommandSuccessContextualizedType } from '../dmpconnectActions';
import { formatCreateFolderMssWs, formatDeleteFolderMssWs, formatDownloadAttachementFromMssWs, formatFullSearchMssMessages, formatFullSearchMssMessagesIMAP, formatGetFoldersFromMssWs, formatMoveMssMessages, formatRenameFolderMssWs, formatSearchMessagesFromMssWs, formatSendDocumentRestParams, formatSendMssWebEmail, formatSyncMessagesFromMssWs, formatUpdateMessagesFromMssWs } from './commandParamsFormatters';
import commands, { commandSubTypes, commandTypes, generateCommonDpParams, mssSubTypes } from './commands';
import webSocketCommandParams from './webSocketCommandParams';
export var restFormatResponse = _defineProperty({}, apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION, {
  formatter: function formatter(response) {
    if (!response.ExistingTestAnswer) {
      var s_status = response.s_status,
        s_mail = response.s_mail,
        s_mobilePhone = response.s_mobilePhone,
        i_treatingPhysician = response.i_treatingPhysician,
        data = _objectWithoutProperties(response, ["s_status", "s_mail", "s_mobilePhone", "i_treatingPhysician"]);
      return {
        ExistingTestAnswer: _objectSpread({}, data),
        s_status: s_status,
        s_mail: s_mail,
        s_mobilePhone: s_mobilePhone,
        i_treatingPhysician: i_treatingPhysician
      };
    }
    return response;
  }
});
export var getCommonRestDPParams = function getCommonRestDPParams(state, esUser) {
  var dmpconnectESConfiguration = state.dmpconnectESConfiguration,
    dmpconnectConnectorConfig = state.dmpconnectConnectorConfig;
  var esPracticeSetting = getConfigurationValue('practiceSetting', dmpconnectESConfiguration);
  var esActivitySector = getConfigurationValue('activitySector', dmpconnectESConfiguration);
  var esPracticeLocationName = getConfigurationValue('practiceLocationName', dmpconnectESConfiguration);
  var licensingGroupId = getConfigurationValue('licensingGroupId', dmpconnectConnectorConfig);
  if (!esUser) {
    return null;
  }
  return _objectSpread({
    EsUser: {
      HP: {
        i_authenticationMode: userAuthenticationModes.Password,
        s_ppid: esUser.ppId,
        s_authenticationPasswordSha1: esUser.s_authenticationPasswordSha1,
        s_signaturePasswordSha1: esUser.s_signaturePasswordSha1,
        s_serviceName: esUser.serviceName
      },
      PracticeLocation: {
        s_name: esPracticeLocationName,
        s_activitySector: esActivitySector,
        s_practiceSettings: esPracticeSetting
      }
    },
    s_licensingGroupId: licensingGroupId
  }, generateCommonDpParams(state));
};
export var getCommonRestParams = function getCommonRestParams(state, esUser, air, subType, commandName) {
  var dmpconnectConnectorConfig = state.dmpconnectConnectorConfig,
    dmpconnectESConfiguration = state.dmpconnectESConfiguration,
    _state$dmpconnect = state.dmpconnect,
    secretConnection = _state$dmpconnect.secretConnection,
    _state$dmpconnect$api = _state$dmpconnect[apiSections.DMP_ACCESS_MODE_SECTION],
    _state$dmpconnect$api2 = _state$dmpconnect$api === void 0 ? {} : _state$dmpconnect$api,
    _state$dmpconnect$api3 = _state$dmpconnect$api2.params,
    _state$dmpconnect$api4 = _state$dmpconnect$api3 === void 0 ? {} : _state$dmpconnect$api3,
    _state$dmpconnect$api5 = _state$dmpconnect$api4.i_accessMode,
    i_accessMode = _state$dmpconnect$api5 === void 0 ? accessModes.NormalAccess : _state$dmpconnect$api5,
    _state$dmpconnect$api6 = _state$dmpconnect$api4.s_reason,
    s_reason = _state$dmpconnect$api6 === void 0 ? '' : _state$dmpconnect$api6;
  var serverName = getConfigurationValue('serverName', dmpconnectConnectorConfig);
  var licensingGroupId = getConfigurationValue('licensingGroupId', dmpconnectConnectorConfig);
  var esPracticeSetting = getConfigurationValue('practiceSetting', dmpconnectESConfiguration);
  var esActivitySector = getConfigurationValue('activitySector', dmpconnectESConfiguration);
  var esPracticeLocationName = getConfigurationValue('practiceLocationName', dmpconnectESConfiguration);
  var hpAuthenticationMode = getConfigurationValue('hpAuthenticationMode', dmpconnectESConfiguration) || 8;
  var hpAuthenticationContext = getConfigurationValue('hpAuthenticationContext', dmpconnectESConfiguration) || 7;
  var esId = getConfigurationValue('es_id', dmpconnectESConfiguration);
  var esIdMss = getConfigurationValue('es_id_mss', dmpconnectESConfiguration);
  var _getActiveMssAccountC = getActiveMssAccountConfig(state),
    mssEsId = _getActiveMssAccountC.mssEsId;
  var esIdINSI = getConfigurationValue('es_id_insi', dmpconnectESConfiguration);
  // const esIdAir = getConfigurationValue('es_id_air', dmpconnectESConfiguration);
  var professions = getInteropCodesFromState(state, 'professions');
  if (esUser === null) {
    return null;
  }
  hpAuthenticationMode = esUser.hpAuthenticationMode || hpAuthenticationMode;
  hpAuthenticationContext = esUser.hpAuthenticationContext || hpAuthenticationContext;
  var professionOid = esUser.hpProfessionOid;
  if (!esUser.hpProfessionOid && esUser.hpProfession && professions) {
    var profession = professions.find(function (p) {
      return p.code === esUser.hpProfession;
    });
    professionOid = profession.oid;
  }
  var user = {
    EsUser: {
      HP: {
        s_name: esUser.hpName,
        s_given: esUser.hpGiven,
        s_codeProfession: esUser.hpProfession,
        s_professionOid: professionOid,
        s_codeSpecialty: esUser.hpSpeciality,
        s_internalId: esUser.hpInternalId,
        i_authenticationMode: hpAuthenticationMode,
        s_serviceName: esUser.serviceName
      },
      PracticeLocation: {
        s_name: esPracticeLocationName,
        s_activitySector: esActivitySector,
        s_practiceSettings: esPracticeSetting
      }
    },
    s_esId: esId,
    s_licensingGroupId: licensingGroupId
  };
  if (subType === commandSubTypes.INSI) {
    user = _objectSpread({}, user, {
      s_esId: esIdINSI
    });
  }
  if (subType !== commandSubTypes.INSI) {
    user = _objectSpread({}, user, {
      s_dmpUrl: serverName,
      i_confidentialityLevel: Number(secretConnection),
      i_accessMode: Number(i_accessMode),
      s_accessModeReason: s_reason
    });
  }
  if (subType === commandSubTypes.MSS) {
    var isMssExtraIdRequired = commands.sendMssSmtpEmail === commandName;
    var mssAuthenticationId = state.dmpConnectPersistedAppConfiguration.mssAuthenticationId;
    user = _objectSpread({}, user, {
      s_authenticationId: mssAuthenticationId
    });
    if (isMssExtraIdRequired) {
      user = _objectSpread({}, user, {
        s_mssEsId: mssEsId || esIdMss,
        s_dmpEsId: esId
      });
    } else {
      user = _objectSpread({}, user, {
        s_esId: mssEsId || esIdMss
      });
    }
  }
  if (air && subType !== commandSubTypes.MSS && subType !== commandSubTypes.INSI) {
    user.EsUser.HP.i_authenticationContext = hpAuthenticationContext;
    user.s_airEsId = esId;
    user.s_dmpEsId = esId;
  }
  return user;
};
var restCommandParams = (_restCommandParams = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.activeFeatures, {
  type: commandTypes.REST,
  endpoint: '/activeFeatures'
}), commands.getTimeSynchronizationDifference, {
  type: commandTypes.REST,
  endpoint: '/getTimeSynchronizationDifference'
}), commands.setDMPAccessMode, {
  forwardTo: dmpCommandSuccessContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)
}), commands.findPatient, {
  type: commandTypes.REST,
  endpoint: '/findpatients',
  timeout: 180,
  paramsGetter: function paramsGetter(params) {
    var s_givenName = params.s_givenName,
      parameters = _objectWithoutProperties(params, ["s_givenName"]);
    return _objectSpread({}, parameters, {
      s_given: s_givenName
    });
  }
}), commands.getDMPStatus, {
  type: commandTypes.REST,
  endpoint: '/getdmpstatus',
  timeout: 60
}), commands.getCertifiedIdentity, {
  type: commandTypes.REST,
  endpoint: '/getcertifiedidentity'
}), commands.updateUserDmpAccessAuthorization, {
  type: commandTypes.REST,
  endpoint: '/updatedmpaccessauthorization'
}), commands.setConfidentialityLevel, {
  type: commandTypes.REST,
  forwardTo: dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST)
}), commands.getDmpAdministrativeData, {
  type: commandTypes.REST,
  endpoint: '/getdmpadministrativedata'
}), commands.deleteDocument, {
  type: commandTypes.REST,
  endpoint: '/deleteDocument',
  paramsGetter: function paramsGetter(params) {
    var s_uniqueId = params.s_uniqueId,
      s_uuid = params.s_uuid,
      s_healthCareSettings = params.s_healthCareSettings,
      rest = _objectWithoutProperties(params, ["s_uniqueId", "s_uuid", "s_healthCareSettings"]);
    return _objectSpread({}, rest, {
      s_documentUniqueId: s_uniqueId,
      s_documentUuid: s_uuid,
      s_healthcareSetting: s_healthCareSettings
    });
  }
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.deleteArchivedDocument, {
  type: commandTypes.REST,
  endpoint: '/deleteArchivedDocument',
  paramsGetter: function paramsGetter(params) {
    var s_uniqueId = params.s_uniqueId,
      s_uuid = params.s_uuid,
      s_healthCareSettings = params.s_healthCareSettings,
      rest = _objectWithoutProperties(params, ["s_uniqueId", "s_uuid", "s_healthCareSettings"]);
    return _objectSpread({}, rest, {
      s_documentUniqueId: s_uniqueId,
      s_documentUuid: s_uuid,
      s_healthcareSetting: s_healthCareSettings
    });
  }
}), commands.createDMPAndOtp, {
  type: commandTypes.REST,
  endpoint: '/createdmp'
}), commands.reactivateDMP, {
  type: commandTypes.REST,
  endpoint: '/reactivatedmp'
}), commands.updateDmpAdministrativeData, {
  type: commandTypes.REST,
  endpoint: '/updatedmpadministrativedata'
}), commands.getPatientWebAccessPdf, {
  type: commandTypes.REST,
  endpoint: '/getpatientwebaccesspdf'
}), commands.getInsNirFromInsC, {
  type: commandTypes.REST,
  endpoint: '/getInsNirFromInsC'
}), commands.validateDocuments, {
  type: commandTypes.REST,
  endpoint: '/validateDocuments',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref) {
    var esUser = _ref.esUser,
      ins = _ref.ins,
      base64Content = _ref.base64Content,
      title = _ref.title,
      description = _ref.description,
      category = _ref.category,
      visibility = _ref.visibility,
      format = _ref.format,
      healthcareSetting = _ref.healthcareSetting,
      creationDate = _ref.creationDate,
      serviceStartDate = _ref.serviceStartDate,
      serviceStopDate = _ref.serviceStopDate,
      replacedDocumentId = _ref.replacedDocumentId,
      Informants = _ref.Informants,
      Performer = _ref.Performer,
      TreatingPhycisian = _ref.TreatingPhycisian,
      AdditionalAuthors = _ref.AdditionalAuthors,
      IntendedRecipients = _ref.IntendedRecipients,
      eventCodes = _ref.eventCodes,
      retrieveDocumentUuid = _ref.retrieveDocumentUuid,
      forceSchematronsValidation = _ref.forceSchematronsValidation,
      ignorePdfA1Transparency = _ref.ignorePdfA1Transparency,
      disabledPdfA1Conversion = _ref.disabledPdfA1Conversion,
      versionNumber = _ref.versionNumber,
      setIdRoot = _ref.setIdRoot,
      setIdExtension = _ref.setIdExtension,
      uniqueId = _ref.uniqueId,
      Identity = _ref.Identity,
      transcodeTypeCode = _ref.transcodeTypeCode,
      getCdaHeaders = _ref.getCdaHeaders,
      getContent = _ref.getContent,
      getCdaContent = _ref.getCdaContent,
      stylesheetBase64 = _ref.stylesheetBase64,
      AdditionalPatientIdentifiers = _ref.AdditionalPatientIdentifiers,
      structuredBody = _ref.structuredBody;
    return _objectSpread({}, formatSendDocumentRestParams(esUser, ins, base64Content, title, description, category, visibility, format, healthcareSetting, creationDate, replacedDocumentId, eventCodes, Informants, Performer, TreatingPhycisian, AdditionalAuthors, IntendedRecipients, retrieveDocumentUuid, serviceStartDate, serviceStopDate, forceSchematronsValidation, ignorePdfA1Transparency, disabledPdfA1Conversion, versionNumber, setIdRoot, setIdExtension, uniqueId, Identity, transcodeTypeCode, undefined, AdditionalPatientIdentifiers, getDocumentContent, structuredBody), {
      i_getCdaHeaders: Number(getCdaHeaders),
      i_getContent: Number(getContent),
      i_getCda: Number(getCdaContent),
      s_stylesheetInBase64: stylesheetBase64
    });
  }
}), commands.sendDocument, {
  type: commandTypes.REST,
  endpoint: '/sendsubmissionset',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref2) {
    var esUser = _ref2.esUser,
      ins = _ref2.ins,
      base64Content = _ref2.base64Content,
      title = _ref2.title,
      description = _ref2.description,
      category = _ref2.category,
      visibility = _ref2.visibility,
      format = _ref2.format,
      healthcareSetting = _ref2.healthcareSetting,
      creationDate = _ref2.creationDate,
      serviceStartDate = _ref2.serviceStartDate,
      serviceStopDate = _ref2.serviceStopDate,
      replacedDocumentId = _ref2.replacedDocumentId,
      Informants = _ref2.Informants,
      Performer = _ref2.Performer,
      TreatingPhycisian = _ref2.TreatingPhycisian,
      AdditionalAuthors = _ref2.AdditionalAuthors,
      IntendedRecipients = _ref2.IntendedRecipients,
      eventCodes = _ref2.eventCodes,
      retrieveDocumentUuid = _ref2.retrieveDocumentUuid,
      forceSchematronsValidation = _ref2.forceSchematronsValidation,
      ignorePdfA1Transparency = _ref2.ignorePdfA1Transparency,
      disabledPdfA1Conversion = _ref2.disabledPdfA1Conversion,
      versionNumber = _ref2.versionNumber,
      setIdRoot = _ref2.setIdRoot,
      setIdExtension = _ref2.setIdExtension,
      uniqueId = _ref2.uniqueId,
      Identity = _ref2.Identity,
      transcodeTypecode = _ref2.transcodeTypecode,
      stylesheetBase64 = _ref2.stylesheetBase64,
      submitEngine = _ref2.submitEngine,
      AdditionalPatientIdentifiers = _ref2.AdditionalPatientIdentifiers,
      getDocumentContent = _ref2.getDocumentContent,
      structuredBody = _ref2.structuredBody;
    return _objectSpread({}, formatSendDocumentRestParams(esUser, ins, base64Content, title, description, category, visibility, format, healthcareSetting, creationDate, replacedDocumentId, eventCodes, Informants, Performer, TreatingPhycisian, AdditionalAuthors, IntendedRecipients, retrieveDocumentUuid, serviceStartDate, serviceStopDate, forceSchematronsValidation, ignorePdfA1Transparency, disabledPdfA1Conversion, versionNumber, setIdRoot, setIdExtension, uniqueId, Identity, transcodeTypecode, stylesheetBase64, submitEngine, AdditionalPatientIdentifiers, getDocumentContent, structuredBody), {
      i_timeout: 600
    });
  }
}), commands.clearPersistantData, {
  type: commandTypes.REST,
  forwardTo: dmpconnectActionConstants.DMPC_CLEAR_PERSISTANT_DATA_FROM_LOCALSTORAGE
}), commands.getPersistantData, {
  type: commandTypes.REST,
  forwardTo: dmpconnectActionConstants.DMPC_GET_PERSISTANT_DATA_FROM_LOCALSTORAGE
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.setPersistantData, {
  type: commandTypes.REST,
  forwardTo: dmpconnectActionConstants.DMPC_SET_PERSISTANT_DATA_TO_LOCALSTORAGE,
  paramsGetter: function paramsGetter(data) {
    return {
      data: data
    };
  }
}), commands.getInteropCodes, {
  type: commandTypes.REST,
  endpoint: '/getInteropCodes'
}), commands.getNosCodes, {
  type: commandTypes.REST,
  endpoint: '/getNosCodes'
}), commands.getCiSisCodes, {
  type: commandTypes.REST,
  endpoint: '/getCiSisCodes'
}), commands.getCisCodes, {
  type: commandTypes.REST,
  commandName: '/getCisCodes'
}), commands.getAtcCodes, {
  type: commandTypes.REST,
  commandName: '/getAtcCodes'
}), commands.getDmpParameters, {
  type: commandTypes.REST,
  endpoint: '/getDmpParameters'
}), commands.getAccessibleDMPList, {
  type: commandTypes.REST,
  endpoint: '/getaccessibledmplist',
  timeout: 600
}), commands.getOtpChannelValue, {
  type: commandTypes.REST,
  endpoint: '/getOtpChannelValue'
}), commands.findDocuments, {
  type: commandTypes.REST,
  endpoint: '/finddocuments',
  timeout: 600
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.getSubmissionSetDocuments, {
  type: commandTypes.REST,
  endpoint: '/getSubmissionSetDocuments'
}), commands.getDocumentSubmissionSetIdByUniqueId, {
  type: commandTypes.REST,
  endpoint: '/getDocumentSubmissionSetId'
}), commands.getDocumentContentByUniqueId, {
  type: commandTypes.REST,
  endpoint: '/getdocumentcontent',
  timeout: 600
}), commands.getDocumentsContentByUniqueId, {
  type: commandTypes.REST,
  endpoint: '/getdocumentscontent',
  timeout: 600
}), commands.updateDocumentVisibilityByUniqueId, {
  type: commandTypes.REST,
  endpoint: '/updatedocumentvisibility'
}), commands.updateDocumentStatusByUniqueId, {
  type: commandTypes.REST,
  endpoint: '/updatedocumentstatus'
}), commands.getStatistics, {
  type: commandTypes.REST,
  endpoint: '/getstatistics'
}), commands.exportCdaDocument, {
  type: commandTypes.REST,
  endpoint: '/exportCdaDocument'
}), commands.exportData, {
  type: commandTypes.REST,
  endpoint: '/exportData'
}), commands.reloadPpCerts, {
  type: commandTypes.REST,
  endpoint: '/reloadPpCerts'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.dpGetMedicationDispensations, {
  type: commandTypes.REST,
  subType: commandSubTypes.DP,
  endpoint: '/dpGetMedicationDispensations'
}), commands.dpDirectory_SearchRecord, {
  type: commandTypes.REST,
  subType: commandSubTypes.DP,
  endpoint: '/dpDirectory_SearchRecord'
}), commands.dpDirectory_GetRecordStatus, {
  type: commandTypes.REST,
  subType: commandSubTypes.DP,
  endpoint: '/dpDirectory_GetRecordStatus'
}), commands.dpDirectory_AddOrUpdateRecord, {
  type: commandTypes.REST,
  subType: commandSubTypes.DP,
  endpoint: '/dpDirectory_AddOrUpdateRecord'
}), commands.dpDirectory_DeleteRecord, {
  type: commandTypes.REST,
  subType: commandSubTypes.DP,
  endpoint: '/dpDirectory_DeleteRecord'
}), commands.getInsFromVitaleCard, _objectSpread({}, webSocketCommandParams[commands.getInsFromVitaleCard])), commands.getInsFromRawVitaleData, {
  type: commandTypes.REST,
  endpoint: '/getInsFromRawVitaleData',
  subType: commandSubTypes.INSI
}), commands.getInsFromIdentityInformation, {
  type: commandTypes.REST,
  endpoint: '/getInsFromIdentityInformation',
  subType: commandSubTypes.INSI
}), commands.checkIdentity, {
  type: commandTypes.REST,
  endpoint: '/checkInsIdentity',
  subType: commandSubTypes.INSI
}), commands.submitInsiBatchValidationSet, {
  type: commandTypes.REST,
  endpoint: '/submitInsiBatchValidationSet',
  subType: commandSubTypes.INSI
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.getInsiBatchValidationSetResult, {
  type: commandTypes.REST,
  endpoint: '/getInsiBatchValidationSetResult',
  subType: commandSubTypes.INSI
}), commands.getMssHpInfos, {
  type: commandTypes.REST,
  endpoint: '/getMssHpInfos',
  subType: commandSubTypes.MSS,
  paramsGetter: function paramsGetter(data) {
    return {
      s_name: data.s_searchName,
      s_given: data.s_searchGiven,
      s_rpps: data.s_searchRPPS,
      s_specialty: data.s_searchSpecialty,
      s_organization: data.s_searchOrganization,
      Query: data.Query
    };
  }
}), commands.performMssAuthentication, {
  type: commandTypes.REST,
  endpoint: '/performMssAuthentication',
  subType: commandSubTypes.MSS
}), commands.initiateMssOtpAuthentication, {
  type: commandTypes.REST,
  endpoint: '/initiateMssOtpAuthentication',
  subType: commandSubTypes.MSS
}), commands.finalizeMssOtpAuthentication, {
  type: commandTypes.REST,
  endpoint: '/finalizeMssOtpAuthentication',
  subType: commandSubTypes.MSS
}), commands.sendMssRequest, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  subType: commandSubTypes.MSS
}), commands.generateMssAttachments, {
  type: commandTypes.REST,
  endpoint: '/generateMssAttachments',
  subType: commandSubTypes.MSS,
  paramsGetter: function paramsGetter(_ref3) {
    var attachments = _ref3.attachments,
      ins = _ref3.ins,
      healthcareSetting = _ref3.healthcareSetting,
      Identity = _ref3.Identity,
      insIsNotQualified = _ref3.insIsNotQualified,
      AdditionalPatientIdentifiers = _ref3.AdditionalPatientIdentifiers,
      disableIheXdmPdfTitlePage = _ref3.disableIheXdmPdfTitlePage,
      disableIheXdmPdfDataMatrixBlock = _ref3.disableIheXdmPdfDataMatrixBlock;
    return {
      Documents: attachments,
      s_ins: ins,
      s_healthcareSetting: healthcareSetting,
      Identity: Identity,
      i_insIsNotQualified: insIsNotQualified,
      AdditionalPatientIdentifiers: AdditionalPatientIdentifiers,
      i_disableIheXdmPdfTitlePage: disableIheXdmPdfTitlePage,
      i_disableIheXdmPdfDataMatrixBlock: disableIheXdmPdfDataMatrixBlock
    };
  },
  timeout: 600
}), commands.sendMssSmtpEmail, {
  smtp: true,
  type: commandTypes.REST,
  endpoint: '/sendMssSmtpEmail',
  subType: commandSubTypes.MSS
}), commands.sendMssWebEmailSoap, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(emailContent) {
    return formatSendMssWebEmail({
      attachments: emailContent.attachments,
      sendReceiptNotification: emailContent.i_askReadAcknowledgement === 1,
      isHtml: emailContent.i_messageContentIsInHtml,
      bcc: emailContent.s_bcc,
      cc: emailContent.s_cc,
      healthcareSetting: emailContent.s_healthcareSetting,
      ins: emailContent.s_ins,
      messageContent: b64DecodeUnicode(emailContent.s_messageContentInBase64),
      recipients: emailContent.s_recipient,
      sender: emailContent.s_senderEmail,
      senderWording: emailContent.s_senderWording,
      replyTo: emailContent.s_replyTo,
      title: emailContent.s_title,
      inReplyToMessageIds: emailContent.s_inReplyToMessageIds,
      references: emailContent.s_references
    });
  },
  subType: commandSubTypes.MSS
}), commands.sendMssWebEmailConnector, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedEmail',
  subType: commandSubTypes.MSS
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.getFoldersMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(email) {
    return formatGetFoldersFromMssWs(email);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapListFolders',
  paramsGetter: function paramsGetter(email) {
    return {
      s_login: email
    };
  },
  subType: commandSubTypes.MSS
})), commands.createFolderMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref4) {
    var email = _ref4.email,
      folderName = _ref4.folderName,
      folderParentId = _ref4.folderParentId;
    return formatCreateFolderMssWs(email, folderName, folderParentId);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapCreateFolder',
  paramsGetter: function paramsGetter(_ref5) {
    var email = _ref5.email,
      folderName = _ref5.folderName;
    return {
      s_login: email,
      s_folderName: folderName
    };
  },
  subType: commandSubTypes.MSS
})), commands.deleteFolderMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref6) {
    var email = _ref6.email,
      folderId = _ref6.folderId;
    return formatDeleteFolderMssWs(email, folderId);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapDeleteFolder',
  paramsGetter: function paramsGetter(_ref7) {
    var email = _ref7.email,
      folderId = _ref7.folderId;
    return {
      s_login: email,
      s_folderName: folderId
    };
  },
  subType: commandSubTypes.MSS
})), commands.renameFolderMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref8) {
    var email = _ref8.email,
      folderId = _ref8.folderId,
      newFolderName = _ref8.newFolderName;
    return formatRenameFolderMssWs(email, folderId, newFolderName);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapRenameFolder',
  paramsGetter: function paramsGetter(_ref9) {
    var email = _ref9.email,
      folderId = _ref9.folderId,
      newFolderName = _ref9.newFolderName;
    return {
      s_login: email,
      s_oldFolderName: folderId,
      s_newFolderName: newFolderName
    };
  },
  subType: commandSubTypes.MSS
})), commands.getSearchMessagesMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref10) {
    var email = _ref10.email,
      folderId = _ref10.folderId,
      offset = _ref10.offset,
      limit = _ref10.limit;
    return formatSearchMessagesFromMssWs(email, folderId, offset, limit);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapListMessages',
  paramsGetter: function paramsGetter(_ref11) {
    var email = _ref11.email,
      folderId = _ref11.folderId;
    return {
      s_login: email,
      s_folderName: folderId
    };
  },
  subType: commandSubTypes.MSS
})), commands.getMessageContentMss, _defineProperty({}, mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapGetMessage',
  paramsGetter: function paramsGetter(_ref12) {
    var email = _ref12.email,
      folderId = _ref12.folderId,
      messageId = _ref12.messageId;
    return {
      s_login: email,
      s_folderName: folderId,
      s_uid: messageId
    };
  },
  subType: commandSubTypes.MSS
})), commands.getSyncMessagesMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref13) {
    var email = _ref13.email,
      folderId = _ref13.folderId,
      token = _ref13.token;
    return formatSyncMessagesFromMssWs(email, folderId, token);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  forwardTo: mssActionConstants.IMAP_SYNC_MESSAGES
})), commands.updateMessagesMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref14) {
    var email = _ref14.email,
      messageIds = _ref14.messageIds,
      operation = _ref14.operation;
    return formatUpdateMessagesFromMssWs(email, messageIds, operation);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapUpdateMessageFlags',
  paramsGetter: function paramsGetter(_ref15) {
    var email = _ref15.email,
      messageIds = _ref15.messageIds,
      operation = _ref15.operation,
      folderId = _ref15.folderId,
      add = _ref15.add;
    return {
      s_login: email,
      s_uid: messageIds[0],
      s_folderName: folderId,
      i_mode: add ? 1 : 2,
      Flags: [operation === 'READ' ? '\\Seen' : '']
    };
  },
  subType: commandSubTypes.MSS
})), commands.deleteMssMessages, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref16) {
    var email = _ref16.email,
      messageIds = _ref16.messageIds;
    return formatUpdateMessagesFromMssWs(email, messageIds, 'DELETE');
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapDeleteMessage',
  paramsGetter: function paramsGetter(_ref17) {
    var email = _ref17.email,
      messageIds = _ref17.messageIds,
      folderId = _ref17.folderId;
    return {
      s_login: email,
      s_uid: messageIds[0],
      s_folderName: folderId
    };
  },
  subType: commandSubTypes.MSS
})), commands.moveMSSMessages, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref18) {
    var email = _ref18.email,
      messageIds = _ref18.messageIds,
      destinationFolderId = _ref18.destinationFolderId;
    return formatMoveMssMessages(email, messageIds, destinationFolderId);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapMoveMessage',
  paramsGetter: function paramsGetter(_ref19) {
    var email = _ref19.email,
      messageIds = _ref19.messageIds,
      destinationFolderId = _ref19.destinationFolderId,
      sourceFolderId = _ref19.sourceFolderId;
    return {
      s_login: email,
      s_uid: messageIds[0],
      s_sourceFolderName: sourceFolderId,
      s_destinationFolderName: destinationFolderId
    };
  },
  subType: commandSubTypes.MSS
})), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.fullSearchMssMessages, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref20) {
    var email = _ref20.email,
      folderId = _ref20.folderId,
      from = _ref20.from,
      to = _ref20.to,
      subject = _ref20.subject,
      body = _ref20.body,
      dateFrom = _ref20.dateFrom,
      dateTo = _ref20.dateTo,
      hasAttachment = _ref20.hasAttachment;
    return formatFullSearchMssMessages(email, folderId, from, to, subject, body, dateFrom, dateTo, hasAttachment);
  },
  subType: commandSubTypes.MSS
}), mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  endpoint: '/imapSearchMessages',
  paramsGetter: function paramsGetter(_ref21) {
    var email = _ref21.email,
      folderId = _ref21.folderId,
      from = _ref21.from,
      to = _ref21.to,
      subject = _ref21.subject,
      body = _ref21.body,
      dateFrom = _ref21.dateFrom,
      dateTo = _ref21.dateTo,
      hasAttachment = _ref21.hasAttachment;
    return formatFullSearchMssMessagesIMAP(email, folderId, from, to, subject, body, dateFrom, dateTo, hasAttachment);
  },
  subType: commandSubTypes.MSS
})), commands.getDownloadAttachmentMSS, {
  type: commandTypes.REST,
  endpoint: '/sendMssAuthenticatedRequest',
  paramsGetter: function paramsGetter(_ref22) {
    var email = _ref22.email,
      messageId = _ref22.messageId,
      part = _ref22.part;
    return formatDownloadAttachementFromMssWs(email, messageId, part);
  },
  subType: commandSubTypes.MSS
}), commands.getDocumentsFromIheXdm, {
  type: commandTypes.REST,
  endpoint: '/getDocumentsFromIheXdm',
  paramsGetter: function paramsGetter(iheXdmContentArchiveInBase64) {
    return {
      s_iheXdmContentArchiveInBase64: iheXdmContentArchiveInBase64
    };
  }
}), commands.imapAppendMessage, _defineProperty({}, mssSubTypes.IMAP, {
  imap: true,
  type: commandTypes.REST,
  subType: commandSubTypes.MSS,
  endpoint: '/imapAppendMessage',
  paramsGetter: function paramsGetter(_ref23) {
    var email = _ref23.email,
      folderName = _ref23.folderName,
      messageInBase64 = _ref23.messageInBase64;
    return {
      s_login: email,
      s_folderName: folderName,
      s_messageInBase64: messageInBase64
    };
  }
})), commands.getTd010Vihf, {
  type: commandTypes.REST,
  endpoint: '/getTd010Vihf'
}), commands.searchFhirHealthDirectory, {
  type: commandTypes.REST,
  endpoint: '/searchFhirHealthDirectory',
  timeout: 600
}), commands.searchFhirAllHpOfStructure, {
  type: commandTypes.REST,
  endpoint: '/searchFhirAllHpOfStructure',
  timeout: 600
}), commands.pscAuthenticateUserCiba, {
  type: commandTypes.REST,
  endpoint: '/pscAuthenticateUserCiba',
  timeout: 600
}), commands.isDcParamsRegistered, _objectSpread({}, webSocketCommandParams[commands.isDcParamsRegistered])), commands.registerDcParams, _objectSpread({}, webSocketCommandParams[commands.registerDcParams])), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.unregisterDcParams, _objectSpread({}, webSocketCommandParams[commands.unregisterDcParams])), commands.openSession, _objectSpread({}, webSocketCommandParams[commands.openSession])), commands.closeSession, _objectSpread({}, webSocketCommandParams[commands.closeSession])), commands.getSessionState, _objectSpread({}, webSocketCommandParams[commands.getSessionState])), commands.sessionExists, _objectSpread({}, webSocketCommandParams[commands.sessionExists])), commands.getPcscReaders, _objectSpread({}, webSocketCommandParams[commands.getPcscReaders])), commands.getVitaleXmlContent, _objectSpread({}, webSocketCommandParams[commands.getVitaleXmlContent])), commands.getVitaleCard, _objectSpread({}, webSocketCommandParams[commands.getVitaleCard])), commands.setVitaleXmlContent, _objectSpread({}, webSocketCommandParams[commands.setVitaleXmlContent])), commands.readVitaleCard, _objectSpread({}, webSocketCommandParams[commands.readVitaleCard])), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_restCommandParams, commands.getNdp, _objectSpread({}, webSocketCommandParams[commands.getNdp])), commands.createTLSiConnector, _objectSpread({}, webSocketCommandParams[commands.createTLSiConnector])), commands.getInsFromVitaleCard, _objectSpread({}, webSocketCommandParams[commands.getInsFromVitaleCard])), commands.getApCvContext, _objectSpread({}, webSocketCommandParams[commands.getApCvContext])), commands.getNfcApCvUserData, _objectSpread({}, webSocketCommandParams[commands.getNfcApCvUserData])), commands.getNfcCard, _objectSpread({}, webSocketCommandParams[commands.getNfcCard])));
export default restCommandParams;